import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  { path: '/login', component: () => import('@/views/login/index'), hidden: true },
  { path: '/404', component: () => import('@/views/404'), hidden: true },
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: { title: '首页', icon: 'home' }
    }]
  }
]

export const asyncRouterMap = [
  // 商品管理
  {
    path: '/commodityManagement',
    component: Layout,
    // redirect: '/commodityManagement/commodityInfor',
    name: 'commodityManagement',
    meta: { title: '商品管理', icon: 'order' },
    children: [
      {
        path: 'commodityInfor',
        name: 'commodityInfor',
        component: () => import('@/views/commodityManagement/commodityInfor/index'),
        meta: { title: '商品类型', icon: 'order' },
      },
      {
        path: 'commodityGroup',
        name: 'commodityGroup',
        component: () => import('@/views/commodityManagement/commodityGroup/index'),
        meta: { title: '商品信息', icon: 'order' },
      },
    ]
  },
  // 水卡管理
  {
    path: '/waterCard',
    component: Layout,
    // redirect: '/waterCard/waterCardList',
    name: 'waterCard',
    meta: { title: '水卡管理', icon: 'order' },
    children: [
      {
        path: 'salesOut',
        name: 'salesOut',
        component: () => import('@/views/salesManagement/salesOut/index'),
        meta: { title: '销售出库', icon: 'order' },
      },
      {
        path: 'cardCreate',
        name: 'cardCreate',
        component: () => import('@/views/waterCard/cardCreate/index'),
        meta: { title: '创建水卡', icon: 'product-list' }
      },
      {
        path: 'cardInfor',
        name: 'cardInfor',
        component: () => import('@/views/waterCard/cardInfor/index'),
        meta: { title: '水卡信息', icon: 'product-list' }
      },
      {
        path: 'cardType',
        name: 'cardType',
        component: () => import('@/views/waterCard/cardType/index'),
        meta: { title: '水卡类型', icon: 'product-list' }
      },
      {
        path: 'inventory',
        name: 'inventory',
        component: () => import('@/views/waterCard/inventory/index'),
        meta: { title: '统计', icon: 'product-list' }
      },
      {
        path: 'freight',
        name: 'freight',
        component: () => import('@/views/waterCard/freight/index'),
        meta: { title: '运费设置', icon: 'product-list' }
      },
      {
        path: 'waterCardSummary',
        name: 'waterCardSummary',
        component: () => import('@/views/waterCard/waterCardSummary/index'),
        meta: { title: '水卡使用情况汇总', icon: 'order' }
      },
      // {
      //   path: 'waterCardList',
      //   name: 'waterCardList',
      //   component: () => import('@/views/waterCard/waterCardList/index'),
      //   meta: { title: '水卡列表', icon: 'product-list' }
      // },
      
      // {
      //   path: 'waterImgList',
      //   name: 'waterImgList',
      //   component: () => import('@/views/waterCard/waterImgList/index'),
      //   meta: { title: '水卡图片列表', icon: 'order' }
      // },
      {
        path: 'addAdvertise',
        name: 'addHomeAdvertise',
        component: () => import('@/views/waterCard/waterImgList/add'),
        meta: { title: '添加广告' },
        hidden: true
      },
      {
        path: 'updateAdvertise',
        name: 'updateHomeAdvertise',
        component: () => import('@/views/waterCard/waterImgList/update'),
        meta: { title: '编辑广告' },
        hidden: true
      },
      // {
      //   path: 'freight',
      //   name: 'freight',
      //   component: () => import('@/views/waterCard/freight/index'),
      //   meta: { title: '运费规格', icon: 'order' },
      // },
    ]
  },
  // 销售管理
  // {
  //   path: '/salesManagement',
  //   component: Layout,
  //   // redirect: '/sales-management/sales-out',
  //   name: 'salesManagement',
  //   meta: { title: '订单', icon: 'order' },
  //   children: [
  //     {
  //       path: 'salesOut',
  //       name: 'salesOut',
  //       component: () => import('@/views/salesManagement/salesOut/index'),
  //       meta: { title: '销售出库', icon: 'order' },
  //     },
  //   ]
  // },
  // 订单管理
  {
    path: '/oms',
    component: Layout,
    // redirect: '/oms/order',
    name: 'oms',
    meta: { title: '订单', icon: 'order' },
    children: [
      {
        path: 'order',
        name: 'order',
        component: () => import('@/views/oms/order/order'),
        meta: { title: '订单列表', icon: 'order' }
      },
      {
        path: 'deliverable',
        name: 'deliverable',
        component: () => import('@/views/oms/order/deliverable'),
        meta: { title: '已发货订单', icon: 'order' }
      },
      {
        path: 'waitingForDelivery',
        name: 'waitingForDelivery',
        component: () => import('@/views/oms/order/waitingForDelivery'),
        meta: { title: '待发货订单', icon: 'order' }
      },
      {
        path: 'completedOrder',
        name: 'completedOrder',
        component: () => import('@/views/oms/order/completedOrder'),
        meta: { title: '已完成', icon: 'order' }
      },
      {
        path: 'feedback',
        name: 'feedback',
        component: () => import('@/views/oms/order/feedback'),
        meta: { title: '投诉与建议', icon: 'order' }
      },
      {
        path: 'waitingOrderDetail',
        name: 'waitingOrderDetail',
        component: () => import('@/views/oms/order/components/waitingOrderDetail'),
        meta: { title: '订单详情' },
        hidden: true
      },
    ]
  },
  // 系统管理
  {
    path: '/system',
    component: Layout,
    // redirect: '/system/user',
    name: 'system',
    meta: { title: '系统管理', icon: 'ums' },
    children: [
      {
        path: 'user',
        name: 'user',
        component: () => import('@/views/sys/user'),
        meta: { title: '人员管理', icon: 'ums-admin' }
      },
      {
        path: 'dept',
        name: 'dept',
        component: () => import('@/views/sys/dept'),
        meta: { title: '部门管理', icon: 'ums-role' }
      },
      {
        path: 'post',
        name: 'post',
        component: () => import('@/views/sys/post'),
        meta: { title: '岗位管理', icon: 'ums-menu' },

      },
      {
        path: 'account',
        name: 'account',
        component: () => import('@/views/sys/account'),
        meta: { title: '用户管理', icon: 'ums-menu' },

      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/sys/role'),
        meta: { title: '角色管理', icon: 'ums-menu' },

      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/sys/menu'),
        meta: { title: '菜单列表', icon: 'ums-menu' }
      },
      {
        path: 'action',
        name: 'action',
        component: () => import('@/views/sys/action'),
        meta: { title: '菜单权限', icon: 'ums-menu' },
      },
      {
        path: 'modify',
        name: 'modify',
        component: () => import('@/views/sys/modify'),
        meta: { title: '修改密码', icon: 'ums-menu' },
      },
      {
        path: 'log',
        name: 'log',
        component: () => import('@/views/sys/log'),
        meta: { title: '操作日志', icon: 'ums-resource' }
      },
    ]
  },
  { path: '*', redirect: '/404', hidden: true }
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js